<template>
  <button
    class="mt-auto md:mt-0 text-left text-base sm:text-sm focus:outline-none  font-medium transition-all hover:text-purple-600"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {};
</script>
